import React from 'react';
import styled from 'styled-components';
import Card from './card.jsx';

import { Droppable } from 'react-beautiful-dnd';	

import './column.scss';

// import iconStart from './icons/start.png';
import iconYouAre from './icons/you-are.png';
import iconYouAreNot from './icons/you-are-not.png';
import iconTorn from './icons/torn.png';
import iconDoesNotApply from './icons/does-not-apply.png';

const icons = {
	'start': '',
	'you-are': iconYouAre,
	'you-are-not': iconYouAreNot,
	'torn': iconTorn,
	'does-not-apply': iconDoesNotApply,
};

const Container = styled.div`
	margin: 20px;
	border-radius: 2px;
	width: 20%;
	display: flex;
	flex-direction: column;
`;
const Title = styled.p`
	padding: 5px;
`;
const CardList = styled.div`
	padding-left: 5px;
	padding-right: 7px;
	background-color: ${props => (props.isDraggingOver ? 'lightgray' : 'white')};
	border-radius: 5px;
	transition: background-color 0.2s ease;
	flex-grow: 1;
	min-height: 500px;
`;

export default class Column extends React.Component {
	constructor() {
	    super();
		this.columnCardFlip = this.columnCardFlip.bind(this);
		this.rotateRandom = this.rotateRandom.bind(this);
		this.compactCards = this.compactCards.bind(this);
	}

	columnCardFlip(cardId) {
		this.props.onCardFlip(cardId);
	}

	rotateRandom() {
		return Math.random() * 10 - 5;
	}

	compactCards(){
		this.props.onColumnStack(this.props.column.id);
	}

	render() {
		let progressPercentage = this.props.cards.length / 50 * 100 + '%';
		return(
			<Container className="column-wrapper">
				<Droppable droppableId={this.props.column.id}>
					{(provided, snapshot) => (
						<CardList
							ref={provided.innerRef}
					        provider={provided}
							{...provided.droppableProps}
							isDraggingOver={snapshot.isDraggingOver}
						>

							{this.props.column.id === 'start' &&
								<div className="deck-progress-bar">
									<div className="progress-bar-inner" style={{'width': progressPercentage}}></div>
								</div>
							}

							{this.props.column.id !== 'start' && <div className={`columnHeading ${this.props.compact}`}>
								<div className="columnHeadingInner" onClick={this.compactCards}>
									<img src={icons[this.props.column.id]} alt=""/>
									<Title>{this.props.column.title}</Title>
								</div>
							</div>
							}
							<div className="card-list">
								{this.props.cards.map((card, index) => <Card key={card.id} card={card} index={index} cardFlip={this.columnCardFlip} flipped={card.flipped} isBeingDragged={card.isBeingDragged} cardIsBeingDragged={this.props.cardIsBeingDragged} rotate={this.rotateRandom()} compact={this.props.compact} />)}
								{provided.placeholder}
							</div>
						</CardList>
					)}
				</Droppable>
			</Container>
		);
	}
}